// extracted by mini-css-extract-plugin
export var optionGrid = "_8s-7";
export var optionList = "_8s-6";
export var questionsBlock = "_8s-9";
export var spacer = "_8s-5";
export var stepCenteredContent = "_8s-3";
export var stepInner = "_8s-0";
export var stepInnerFullWidth = "_8s-1";
export var stepInnerLockScroll = "_8s-2";
export var stepTransitionFrame = "_8s-4";
export var welcomeBlock = "_8s-8";